import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 0.5rem;
  width: 100%;

  .login-button {
    width: 100%;
  }
`;

export const ForgotPasswordLink = styled.a`
  font-size: 16px;
  color: rgb(3, 0, 165);
`;
